import {Injectable, Inject} from '@angular/core';
import { CanDeactivate } from '@angular/router';
import {OrderDetailsComponent} from '../order-details/order-details.component';

@Injectable()
export class SaveGuard implements CanDeactivate<OrderDetailsComponent> {

    canDeactivate(target: OrderDetailsComponent) {
        if (target.editOrderMode) {
            return target.swalDialog.show();
        }
        return true;
    }

}



// WEBPACK FOOTER //
// ./src/app/order/shared/save.guard.service.ts